export const environment = {
  production: true,
  apiUrl: 'https://internalportal.apis.rogersbank.com/application',
  xApiKey: 'CeySnT01Xe3ql0jTBpusn5i1NyigjutX4afB7uN5',
  contentful: {
    space: 'lhfliosld23m',
    environment: 'master',
    accessToken: 'J2flPYhD2b_rpsrz7X1bD6RKAYTwObDl7xvUsA4s864',
  },
  dynatraceScript:
    'https://js-cdn.dynatrace.com/jstag/17a2d2e42ea/bf45860xtq/99537f5ab2abf1fa_complete.js',
};
